(function () {
    function initCollectionTabs(sectionEl) {
        if (!sectionEl) return;

        const tabButtons = sectionEl.querySelectorAll('.section-tabs__btn');
        const tabPanels = sectionEl.querySelectorAll('.section-tabs__panel');

        function waitForFlickityInstance(carouselEl, callback) {
            let attempts = 0;
            const interval = setInterval(function () {
                attempts++;
                const flkty = typeof Flickity !== 'undefined' ? Flickity.data(carouselEl) : null;

                if (flkty) {
                    clearInterval(interval);
                    callback(flkty);
                } else if (attempts > 100) {
                    clearInterval(interval);
                }
            }, 50);
        }

        function activateTab(targetPanel) {
            if (!targetPanel) return;
            const carouselEl = targetPanel.querySelector('.js-carousel');
            if (!carouselEl) return;

            waitForFlickityInstance(carouselEl, function (flkty) {
                requestAnimationFrame(function () {
                    flkty.resize();
                    flkty.reposition();

                    carouselEl.classList.remove('carousel-loaded--false');
                    carouselEl.classList.add('carousel-loaded--true');
                });
            });
        }

        // Evento de clique exclusivo para alternar abas
        tabButtons.forEach(function (btn) {
            btn.addEventListener('click', function (e) {
                e.preventDefault();
                if (btn.classList.contains('is-active')) return;

                const targetSelector = btn.getAttribute('data-tab-target');
                const targetPanel = sectionEl.querySelector(targetSelector);

                if (!targetPanel) return;

                tabButtons.forEach(b => b.classList.remove('is-active'));
                tabPanels.forEach(p => p.classList.remove('is-active'));

                btn.classList.add('is-active');
                targetPanel.classList.add('is-active');

                activateTab(targetPanel);
            });
        });

        // Garante ajuste no carregamento inicial da aba ativa
        const initialPanel = sectionEl.querySelector('.section-tabs__panel.is-active');
        if (initialPanel) {
            activateTab(initialPanel);
        }
    }

    function setupAllInstances() {
        document.querySelectorAll('.section-featured-collection-tabs').forEach(initCollectionTabs);
    }

    if (document.readyState === 'complete' || document.readyState === 'interactive') {
        setupAllInstances();
    } else {
        document.addEventListener('DOMContentLoaded', setupAllInstances);
    }

    document.addEventListener('shopify:section:load', function (e) {
        const targetSection = e.target.querySelector('.section-featured-collection-tabs') || (e.target.classList.contains('section-featured-collection-tabs') ? e.target : null);
        if (targetSection) {
            initCollectionTabs(targetSection);
        }
    });
})();
